import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { ResetPasswordPage } from '@/features/auth/pages/ResetPasswordPage';
import { UpdatePasswordPage } from '@/features/auth/pages/UpdatePasswordPage';
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';
import { CallDetailRecordsPage } from '@/features/reports/pages/CallDetailRecordsPage';
import { DownloadReportPage } from '@/features/reports/pages/DownloadReportPage';
import { ReportSchedulingLogsPage } from '@/features/reports/pages/ReportSchedulingLogsPage';
import { ReportSchedulingPage } from '@/features/reports/pages/ReportSchedulingPage';
import { ResellerSummaryPage } from '@/features/reports/pages/ResellerSummaryPage';
import { SubUserReportPage } from '@/features/reports/pages/SubUserReportPage';
import { VoicePlanLogsPage } from '@/features/reports/pages/VoicePlanLogsPage';
import { CreateDialerPage } from '@/features/dialers/pages/CreateDialerPage';
import { DialerListPage } from '@/features/dialers/pages/DialerListPage';
import { DialerUsagePage } from '@/features/dialers/pages/DialerUsagePage';
import { DialerUsageRollupPage } from '@/features/dialers/pages/DialerUsageRollupPage';
import { SearchDialerPage } from '@/features/dialers/pages/SearchDialerPage';
import { UpdateDialerPage } from '@/features/dialers/pages/UpdateDialerPage';
import { AddVoiceCampaignPage } from '@/features/voice-campaigns/pages/AddVoiceCampaignPage';
import { CloneVoiceCampaignPage } from '@/features/voice-campaigns/pages/CloneVoiceCampaignPage';
import { UpdateVoiceCampaignPage } from '@/features/voice-campaigns/pages/UpdateVoiceCampaignPage';
import { CreateGroupAgentPage } from '@/features/agent-groups/pages/CreateGroupAgentPage';
import { GroupAgentListPage } from '@/features/agent-groups/pages/GroupAgentListPage';
import { UpdateGroupAgentPage } from '@/features/agent-groups/pages/UpdateGroupAgentPage';
import { AddInboundCampaignPage } from '@/features/inbound-campaigns/pages/AddInboundCampaignPage';
import { CloneInboundCampaignPage } from '@/features/inbound-campaigns/pages/CloneInboundCampaignPage';
import { InboundCampaignHistoricalPage } from '@/features/inbound-campaigns/pages/InboundCampaignHistoricalPage';
import { InboundCampaignLivePage } from '@/features/inbound-campaigns/pages/InboundCampaignLivePage';
import { InboundCampaignSuperAdminPage } from '@/features/inbound-campaigns/pages/InboundCampaignSuperAdminPage';
import { AdminHistoricalCampaignsPage } from '@/features/campaigns/pages/AdminHistoricalCampaignsPage';
import { AdminLiveCampaignsPage } from '@/features/campaigns/pages/AdminLiveCampaignsPage';
import { AddIvrPage } from '@/features/ivr/pages/AddIvrPage';
import { EditIvrPage } from '@/features/ivr/pages/EditIvrPage';
import { IvrListPage } from '@/features/ivr/pages/IvrListPage';
import { AddTtsFlowPage } from '@/features/tts-flow/pages/AddTtsFlowPage';
import { CloneTtsFlowPage } from '@/features/tts-flow/pages/CloneTtsFlowPage';
import { UpdateTtsFlowPage } from '@/features/tts-flow/pages/UpdateTtsFlowPage';
import { TtsFlowListPage } from '@/features/tts-flow/pages/TtsFlowListPage';
import { TtsContLogsPage } from '@/features/tts-flow/pages/TtsContLogsPage';
import { TtsLogsPage } from '@/features/tts-flow/pages/TtsLogsPage';
import { TtsFlowApprovalPage } from '@/features/tts-flow/pages/TtsFlowApprovalPage';
import { MonitoringPage } from '@/features/monitoring/pages/MonitoringPage';
import { FlashMessagesPage } from '@/features/flash-messages/pages/FlashMessagesPage';
import { AclModuleListPage } from '@/features/acl/pages/AclModuleListPage';
import { AclSettingListPage } from '@/features/acl/pages/AclSettingListPage';
import { CreateAclModulePage } from '@/features/acl/pages/CreateAclModulePage';
import { CreateAclSettingPage } from '@/features/acl/pages/CreateAclSettingPage';
import { UpdateAclModulePage } from '@/features/acl/pages/UpdateAclModulePage';
import { UpdateAclSettingPage } from '@/features/acl/pages/UpdateAclSettingPage';
import { AddBlacklistPage } from '@/features/number-actions/pages/AddBlacklistPage';
import { AddWhitelistPage } from '@/features/number-actions/pages/AddWhitelistPage';
import { BlacklistListPage } from '@/features/number-actions/pages/BlacklistListPage';
import { BulkBlacklistDndPage } from '@/features/number-actions/pages/BulkBlacklistDndPage';
import { BulkBlacklistPage } from '@/features/number-actions/pages/BulkBlacklistPage';
import { ManageBlacklistDndPage } from '@/features/number-actions/pages/ManageBlacklistDndPage';
import { SearchNumberPage } from '@/features/number-actions/pages/SearchNumberPage';
import { WhitelistListPage } from '@/features/number-actions/pages/WhitelistListPage';
import { TtsPlanListPage } from '@/features/plans/pages/TtsPlanListPage';
import { VoicePlanListPage } from '@/features/plans/pages/VoicePlanListPage';
import { AllVoiceFilesPage } from '@/features/voice-library/pages/AllVoiceFilesPage';
import { TtsListPage } from '@/features/voice-library/pages/TtsListPage';
import { VoiceFilesPage } from '@/features/voice-library/pages/VoiceFilesPage';
import { CampaignAllocationPage } from '@/features/campaigns/pages/CampaignAllocationPage';
import { CampaignOperationsPage } from '@/features/campaigns/pages/CampaignOperationsPage';
import { CvcSummaryPage } from '@/features/campaigns/pages/CvcSummaryPage';
import { CvcLogsPage } from '@/features/campaigns/pages/CvcLogsPage';
import { ContinuousBaseLogsPage } from '@/features/campaigns/pages/ContinuousBaseLogsPage';
import { PromptVoiceCampaignsPage } from '@/features/campaigns/pages/PromptVoiceCampaignsPage';
import { VoiceCampaignHistoricalPage } from '@/features/campaigns/pages/VoiceCampaignHistoricalPage';
import { VoiceCampaignInfoPage } from '@/features/campaigns/pages/VoiceCampaignInfoPage';
import { VoiceCampaignLivePage } from '@/features/campaigns/pages/VoiceCampaignLivePage';
import { VoiceCampaignSchedulePage } from '@/features/campaigns/pages/VoiceCampaignSchedulePage';
import { ApiKeyHistoricalSummaryPage } from '@/features/api-keys/pages/ApiKeyHistoricalSummaryPage';
import { ApiDocsPage } from '@/features/api-keys/pages/ApiDocsPage';
import { SheetListPage } from '@/features/api-docs/pages/SheetListPage';
import { SheetEditorPage } from '@/features/api-docs/pages/SheetEditorPage';
import { SheetViewPage } from '@/features/api-docs/pages/SheetViewPage';
import { DocumentListPage } from '@/features/api-docs/pages/DocumentListPage';
import { DocumentAddPage } from '@/features/api-docs/pages/DocumentAddPage';
import { ApiDocsViewerPage } from '@/features/api-docs/pages/ApiDocsViewerPage';
import { DocumentViewerPage } from '@/features/api-docs/pages/DocumentViewerPage';
import { ApiKeyListPage } from '@/features/api-keys/pages/ApiKeyListPage';
import { ApiKeySummaryPage } from '@/features/api-keys/pages/ApiKeySummaryPage';
import { CreateApiKeyPage } from '@/features/api-keys/pages/CreateApiKeyPage';
import { UpdateApiKeyPage } from '@/features/api-keys/pages/UpdateApiKeyPage';
import { AllocateCliPage } from '@/features/cli/pages/AllocateCliPage';
import { AllocateCliToUserPage } from '@/features/cli/pages/AllocateCliToUserPage';
import { ArchivedDedicatedCliListPage } from '@/features/cli/pages/ArchivedDedicatedCliListPage';
import { UpdateCliPage } from '@/features/cli/pages/UpdateCliPage';
import { UploadDedicatedCliFilePage } from '@/features/cli/pages/UploadDedicatedCliFilePage';
import { ApiCliListPage } from '@/features/cli/pages/ApiCliListPage';
import { ArchivedApiCliListPage } from '@/features/cli/pages/ArchivedApiCliListPage';
import { ArchivedCliListPage } from '@/features/cli/pages/ArchivedCliListPage';
import { CliListPage } from '@/features/cli/pages/CliListPage';
import { UserDedicatedCliListPage } from '@/features/cli/pages/UserDedicatedCliListPage';
import { PilotCliListPage } from '@/features/cli/pages/PilotCliListPage';
import { UploadApiCliFilePage } from '@/features/cli/pages/UploadApiCliFilePage';
import { UploadCliFilePage } from '@/features/cli/pages/UploadCliFilePage';
import { BulkAddGroupPage } from '@/features/groups/pages/BulkAddGroupPage';
import { BulkUpdateGroupPage } from '@/features/groups/pages/BulkUpdateGroupPage';
import { CreateGroupPage } from '@/features/groups/pages/CreateGroupPage';
import { GroupListPage } from '@/features/groups/pages/GroupListPage';
import { UpdateGroupPage } from '@/features/groups/pages/UpdateGroupPage';
import { BulkAddLocationPage } from '@/features/locations/pages/BulkAddLocationPage';
import { BulkDeleteLocationPage } from '@/features/locations/pages/BulkDeleteLocationPage';
import { CreateLocationPage } from '@/features/locations/pages/CreateLocationPage';
import { LocationListPage } from '@/features/locations/pages/LocationListPage';
import { UpdateLocationPage } from '@/features/locations/pages/UpdateLocationPage';
import { CreateTrunkPage } from '@/features/trunks/pages/CreateTrunkPage';
import { TrunkListPage } from '@/features/trunks/pages/TrunkListPage';
import { UpdateTrunkPage } from '@/features/trunks/pages/UpdateTrunkPage';
import { AddSmsWebhookPage } from '@/features/webhooks/pages/AddSmsWebhookPage';
import { AddVoiceWebhookPage } from '@/features/webhooks/pages/AddVoiceWebhookPage';
import { SmsWebhookListPage } from '@/features/webhooks/pages/SmsWebhookListPage';
import { UpdateSmsWebhookPage } from '@/features/webhooks/pages/UpdateSmsWebhookPage';
import { UpdateVoiceWebhookPage } from '@/features/webhooks/pages/UpdateVoiceWebhookPage';
import { VoiceWebhookListPage } from '@/features/webhooks/pages/VoiceWebhookListPage';
import { CreateSubSuperAdminPage } from '@/features/users/pages/CreateSubSuperAdminPage';
import { CreateSubUserPage } from '@/features/users/pages/CreateSubUserPage';
import { CreateUserPage } from '@/features/users/pages/CreateUserPage';
import { CreditsHistoryPage } from '@/features/users/pages/CreditsHistoryPage';
import { UpdateUserPage } from '@/features/users/pages/UpdateUserPage';
import { UpdateUserSettingPage } from '@/features/users/pages/UpdateUserSettingPage';
import { UserSettingsListPage } from '@/features/users/pages/UserSettingsListPage';
import { SubSuperAdminListPage } from '@/features/users/pages/SubSuperAdminListPage';
import { SubUserListPage } from '@/features/users/pages/SubUserListPage';
import { UpdateSubSuperAdminPage } from '@/features/users/pages/UpdateSubSuperAdminPage';
import { UpdateSubUserPage } from '@/features/users/pages/UpdateSubUserPage';
import { UserListPage } from '@/features/users/pages/UserListPage';
import { UserProfilePage } from '@/features/users/pages/UserProfilePage';
import { ErrorPage } from './ErrorPage';
import { NotFoundPage } from './NotFoundPage';
import { UpdateUserSettingLegacyRedirect } from './UpdateUserSettingLegacyRedirect';
import { RedirectIfAuthed, RequireAuth, RequireModule, RequireTtsStudio } from './guards';
import { ViewAclSettingPage } from '@/features/acl/pages/ViewAclSettingPage';
import { BlockedWordsPage } from '@/features/blocked-words/pages/BlockedWordsPage';
import { ActivityLogsPage } from '@/features/users/pages/ActivityLogsPage';
import { ViewTtsFlowPage } from '@/features/tts-flow/pages/ViewTtsFlowPage';
import { ViewVoiceBasePage } from '@/features/campaigns/pages/ViewVoiceBasePage';
import { CliUsagePage } from '@/features/cli/pages/CliUsagePage';
import { CliLogsPage } from '@/features/cli/pages/CliLogsPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <RedirectIfAuthed>
        <LoginPage />
      </RedirectIfAuthed>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/reset-password',
    element: (
      <RedirectIfAuthed>
        <ResetPasswordPage />
      </RedirectIfAuthed>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/update-password/:token',
    element: <UpdatePasswordPage />,
    errorElement: <ErrorPage />,
  },
  // Preserve the legacy email-link path so existing emails resolve.
  {
    path: '/update-pwd/:token',
    element: <UpdatePasswordPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <DashboardPage /> },

      /* ---- User Management (Phase 6a — shipped) ---- */
      { path: 'user-profile', element: <UserProfilePage /> },
      { path: 'user-list', element: <UserListPage /> },
      { path: 'sub-user-list', element: <SubUserListPage /> },
      { path: 'sub-super-admin/user-list', element: <SubSuperAdminListPage /> },
      { path: 'credits-history', element: <CreditsHistoryPage /> },

      /* ---- User Management (Phase 6b — pending) ---- */
      { path: 'create-user', element: <CreateUserPage /> },
      { path: 'update-user/:userId', element: <UpdateUserPage /> },
      { path: 'create-sub-user', element: <CreateSubUserPage /> },
      { path: 'update-sub-user/:userId', element: <UpdateSubUserPage /> },
      { path: 'sub-super-admin/create-user', element: <CreateSubSuperAdminPage /> },
      { path: 'sub-super-admin/update-user/:userId', element: <UpdateSubSuperAdminPage /> },
      { path: 'user-settings', element: <UserSettingsListPage /> },
      { path: 'user-settings/edit/:subId/:userId', element: <UpdateUserSettingPage /> },
      // Preserve the legacy URL so any deep-link/bookmark still resolves.
      { path: 'update-user_setting/:ids', element: <UpdateUserSettingLegacyRedirect /> },

      /* ---- Phase 2 — read-only screens ---- */
      { path: 'voice-plan-logs', element: <VoicePlanLogsPage /> },
      { path: 'activity-logs', element: <ActivityLogsPage /> },
      { path: 'call-detail-records', element: <CallDetailRecordsPage /> },
      { path: 'sub-user-report', element: <SubUserReportPage /> },
      { path: 'reseller-summary', element: <ResellerSummaryPage /> },

      /* ---- Phase 5 — Reports & Scheduling ---- */
      { path: 'download-report', element: <DownloadReportPage /> },
      { path: 'report-scheduling', element: <ReportSchedulingPage /> },
      { path: 'report-scheduling-logs/:id', element: <ReportSchedulingLogsPage /> },

      /* ---- Phase 3 — Groups / Locations / Trunks ---- */
      { path: 'group-list', element: <GroupListPage /> },
      { path: 'create-group', element: <CreateGroupPage /> },
      { path: 'update-group/:groupId', element: <UpdateGroupPage /> },
      { path: 'location-list', element: <LocationListPage /> },
      { path: 'create-location', element: <CreateLocationPage /> },
      { path: 'update-location/:locationId', element: <UpdateLocationPage /> },
      { path: 'trunk-list', element: <TrunkListPage /> },
      { path: 'create-trunk', element: <CreateTrunkPage /> },
      { path: 'update-trunk/:trunkId', element: <UpdateTrunkPage /> },

      /* ---- Phase 3.2 — Dialers ---- */
      { path: 'dialer-list', element: <DialerListPage /> },
      { path: 'create-dialer', element: <CreateDialerPage /> },
      { path: 'update-dialer/:dialerId', element: <UpdateDialerPage /> },
      { path: 'search-dialer', element: <SearchDialerPage /> },
      { path: 'dialer-usage', element: <DialerUsagePage /> },
      { path: 'dialer-usage-rollup', element: <DialerUsageRollupPage /> },

      /* ---- Phase 3.3 — Bulk membership ---- */
      { path: 'bulk-addition-group', element: <BulkAddGroupPage /> },
      { path: 'bulk-update-group', element: <BulkUpdateGroupPage /> },
      { path: 'bulk-addition-location', element: <BulkAddLocationPage /> },
      { path: 'bulk-location-delete', element: <BulkDeleteLocationPage /> },

      /* ---- Phase 4a — CLI Management ---- */
      { path: 'cli-list', element: <CliListPage /> },
      // USER role — read-only list of own dedicated CLIs (needs Dedicated CLI module 5).
      { path: 'my-dedicated-cli', element: <RequireModule moduleId={5}><UserDedicatedCliListPage /></RequireModule> },
      { path: 'allocate-cli', element: <AllocateCliPage /> },
      { path: 'add-cli', element: <AllocateCliToUserPage /> },
      { path: 'update-cli/:cliId', element: <UpdateCliPage /> },
      { path: 'upload-cli', element: <UploadCliFilePage /> },
      { path: 'upload-dedicated-cli', element: <UploadDedicatedCliFilePage /> },
      { path: 'cli-pilot-list', element: <PilotCliListPage /> },
      { path: 'archived-cli', element: <ArchivedCliListPage /> },
      { path: 'archived-dedicated-cli', element: <ArchivedDedicatedCliListPage /> },
      { path: 'user-archive-cli-list', element: <ArchivedCliListPage /> },
      { path: 'cli-usage', element: <CliUsagePage /> },
      { path: 'cli-logs', element: <RequireModule moduleId={5}><CliLogsPage /></RequireModule> },

      /* ---- Phase 4b — API CLI Management ---- */
      { path: 'cli-api-list', element: <ApiCliListPage /> },
      { path: 'upload-api-cli', element: <UploadApiCliFilePage /> },
      // The pilot search endpoint is shared between CLI and API CLI; same page.
      { path: 'cli-api-pilot-list', element: <PilotCliListPage /> },
      { path: 'archived-api-cli', element: <ArchivedApiCliListPage /> },

      /* ---- Phase 8b — Voice Campaign compose ---- */
      { path: 'add-voice-campaign', element: <AddVoiceCampaignPage /> },
      { path: 'update-voice-campaign/:campaignId', element: <UpdateVoiceCampaignPage /> },
      { path: 'clone-voice-campaign/:campaignId', element: <CloneVoiceCampaignPage /> },

      /* ---- Phase 8a — Voice Campaign summaries ---- */
      { path: 'voice-campaign-summary', element: <VoiceCampaignLivePage /> },
      { path: 'historical-voice-campaign-summary', element: <VoiceCampaignHistoricalPage /> },
      { path: 'schedule-voice-campaign-summary', element: <VoiceCampaignSchedulePage /> },
      { path: 'voice-superadmin-campaign-summary', element: <AdminLiveCampaignsPage /> },
      { path: 'historical-campaign-summary-superadmin', element: <AdminHistoricalCampaignsPage /> },
      { path: 'prompt-voice-superadmin-campaign-summary', element: <PromptVoiceCampaignsPage /> },
      { path: 'voice-campaign-info/:id', element: <VoiceCampaignInfoPage /> },

      /* ---- Phase 8c — Campaign Operations + CvC summary ---- */
      { path: 'campaign-operations', element: <CampaignOperationsPage /> },
      { path: 'cvc-summary', element: <CvcSummaryPage /> },
      { path: 'cvc-logs', element: <CvcLogsPage /> },
      { path: 'continuous-base-logs/:campaignId', element: <ContinuousBaseLogsPage /> },

      /* ---- Phase 8d — Inbound Campaign listings ---- */
      { path: 'inbound-campaign-list', element: <RequireModule moduleId={6}><InboundCampaignLivePage /></RequireModule> },
      { path: 'inbound-campaign-historical-list', element: <RequireModule moduleId={6}><InboundCampaignHistoricalPage /></RequireModule> },
      { path: 'inbound-superadmin-campaign-summary', element: <RequireModule moduleId={6}><InboundCampaignSuperAdminPage /></RequireModule> },

      /* ---- Phase 8f — Manage Campaign Allocation ---- */
      { path: 'manage-campaigns-superadmin', element: <CampaignAllocationPage /> },
      { path: 'view-voice-base', element: <ViewVoiceBasePage /> },

      /* ---- Phase 9a — Custom IVR builder ---- */
      { path: 'ivr-list', element: <RequireModule moduleId={1}><IvrListPage /></RequireModule> },
      { path: 'add-ivr', element: <RequireModule moduleId={1}><AddIvrPage /></RequireModule> },
      { path: 'ivr/:id', element: <RequireModule moduleId={1}><EditIvrPage /></RequireModule> },

      /* ---- Phase 9b — TTS Flow builder ---- */
      { path: 'tts-flow-list', element: <RequireTtsStudio><TtsFlowListPage /></RequireTtsStudio> },
      { path: 'add-tts-flow', element: <RequireTtsStudio><AddTtsFlowPage /></RequireTtsStudio> },
      { path: 'view-tts-flow/:ttsFlowId', element: <RequireTtsStudio><ViewTtsFlowPage /></RequireTtsStudio> },
      { path: 'clone-tts-flow/:ttsFlowId', element: <RequireTtsStudio><CloneTtsFlowPage /></RequireTtsStudio> },
      { path: 'update-tts-flow/:ttsFlowId', element: <RequireTtsStudio><UpdateTtsFlowPage /></RequireTtsStudio> },
      { path: 'tts-flow-cont-logs', element: <RequireTtsStudio><TtsContLogsPage /></RequireTtsStudio> },
      { path: 'tts-flow-approval', element: <RequireTtsStudio aclPath="TTS Studio.Approval"><TtsFlowApprovalPage /></RequireTtsStudio> },
      { path: 'tts-flow-logs', element: <RequireTtsStudio aclPath="TTS Studio.Logs"><TtsLogsPage /></RequireTtsStudio> },


      /* ---- Phase 9c — Voice Library (prompts + TTS) ---- */
      { path: 'voice-files', element: <VoiceFilesPage /> },
      { path: 'all-voice-files', element: <AllVoiceFilesPage /> },
      { path: 'tts-list', element: <TtsListPage /> },

      /* ---- Phase 8e — Agent Groups + Inbound Add/Clone ---- */
      { path: 'group-agent-list', element: <GroupAgentListPage /> },
      { path: 'create-group-agent', element: <CreateGroupAgentPage /> },
      { path: 'update-group-agent/:groupId', element: <UpdateGroupAgentPage /> },
      { path: 'add-inbound-campaign', element: <RequireModule moduleId={6}><AddInboundCampaignPage /></RequireModule> },
      { path: 'clone-inbound-campaign/:campaignId', element: <RequireModule moduleId={6}><CloneInboundCampaignPage /></RequireModule> },

      /* ---- Phase 7 — Webhooks ---- */
      { path: 'webhook-list', element: <VoiceWebhookListPage /> },
      { path: 'add-webhooks', element: <AddVoiceWebhookPage /> },
      { path: 'update-webhooks/:id', element: <UpdateVoiceWebhookPage /> },
      { path: 'sms-webhook-list', element: <RequireModule moduleId={9}><SmsWebhookListPage /></RequireModule> },
      { path: 'add-sms-webhooks', element: <RequireModule moduleId={9}><AddSmsWebhookPage /></RequireModule> },
      { path: 'update-sms-webhooks/:id', element: <RequireModule moduleId={9}><UpdateSmsWebhookPage /></RequireModule> },

      /* ---- Phase 4c — API Keys ---- */
      { path: 'user-api-key-list', element: <ApiKeyListPage /> },
      { path: 'create-api-key', element: <CreateApiKeyPage /> },
      { path: 'update-api-key/:id', element: <UpdateApiKeyPage /> },
      { path: 'api-key-summary-list', element: <ApiKeySummaryPage /> },
      { path: 'api-key-historical-summary-list', element: <ApiKeyHistoricalSummaryPage /> },
      /* ---- API Docs (same URLs as old_obd) ---- */
      { path: 'api-docs', element: <RequireModule moduleId={16}><ApiDocsViewerPage /></RequireModule> },
      { path: 'api-docs/document/:documentId', element: <RequireModule moduleId={16}><DocumentViewerPage /></RequireModule> },
      { path: 'api-docs/:sheetId', element: <RequireModule moduleId={16}><ApiDocsViewerPage /></RequireModule> },
      { path: 'api-docs-reference', element: <ApiDocsPage /> },
      { path: 'superadmin-api-docs/sheet-content', element: <SheetListPage /> },
      { path: 'superadmin-api-docs/sheet-content/add', element: <SheetEditorPage /> },
      { path: 'superadmin-api-docs/sheet-content/edit/:id', element: <SheetEditorPage /> },
      { path: 'superadmin-api-docs/sheet-content/view/:id', element: <SheetViewPage /> },
      { path: 'superadmin-api-docs/upload-document', element: <DocumentListPage /> },
      { path: 'superadmin-api-docs/upload-document/add', element: <DocumentAddPage /> },

      /* ---- Other modules (still placeholders) ---- */
      { path: 'monitoring', element: <MonitoringPage /> },
      { path: 'flash-messages', element: <FlashMessagesPage /> },

      /* ---- Access Control (ACL) ---- */
      { path: 'module', element: <AclModuleListPage /> },
      { path: 'create-module', element: <CreateAclModulePage /> },
      { path: 'update-module/:mid', element: <UpdateAclModulePage /> },
      { path: 'acl-settings', element: <AclSettingListPage /> },
      { path: 'create-acl-settings', element: <CreateAclSettingPage /> },
      { path: 'update-acl-settings/:id', element: <UpdateAclSettingPage /> },

      /* ---- Number Actions ---- */
      { path: 'voice-blacklist', element: <BlacklistListPage /> },
      { path: 'add-voice-blacklist', element: <AddBlacklistPage /> },
      { path: 'bulk-voice-blacklist', element: <BulkBlacklistPage /> },
      { path: 'add-blacklist-dnd', element: <ManageBlacklistDndPage /> },
      { path: 'bulk-blacklist-dnd', element: <BulkBlacklistDndPage /> },
      { path: 'view-whitelist', element: <WhitelistListPage /> },
      { path: 'add-whitelist', element: <AddWhitelistPage /> },
      { path: 'search-blacklist-dnd', element: <SearchNumberPage /> },

      /* ---- Phase 10 — Voice Plans + TTS Plans ---- */
      { path: 'voice-plans', element: <VoicePlanListPage /> },
      { path: 'tts-plans', element: <TtsPlanListPage /> },

      { path: 'view-acl-settings/:id', element: <ViewAclSettingPage /> },

      /* ---- Blocked Words (SADMIN) ---- */
      { path: 'blocked-words', element: <BlockedWordsPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
